import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { AuthJwtService } from '../../../services/auth-jwt.service';
import { ModalTemplatesService } from '../../../services/modal-templates.service';

@Component({
  selector: '[app-menu]',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit, OnDestroy {
  @Input() items: any[] = [];
  @Input() excludedLinkClass: string = '';
  @Input() hasLogout: boolean = false;
  @Input() onNavbarCollapse!: Subject<void>;
  private destroyOnNavbarCollapse$ = new Subject<void>();

  menuCollapsedItems: { [key: string]: boolean } = {};

  constructor(
    private router: Router,
    private authJwtService: AuthJwtService,
    private modalTemplatesService: ModalTemplatesService
  ) { }

  ngOnInit(): void {
    if (this.onNavbarCollapse) {
      this.onNavbarCollapse
        .pipe(takeUntil(this.destroyOnNavbarCollapse$))
        .subscribe(() => this.closeMenuCollapse());
    }
  }

  ngOnDestroy(): void {
    this.destroyOnNavbarCollapse$.next();
    this.destroyOnNavbarCollapse$.complete();
  }

  logout() {
    this.authJwtService.logout();
    this.router.navigate(['/login']);
  }

  toggleMenuCollapse(id: string): void {
    this.menuCollapsedItems[id] = !this.menuCollapsedItems[id];
  }

  closeMenuCollapse() {
    this.menuCollapsedItems = {}
  }

  /**
   * Abre la modal de información legal
   */
  openLegalModal(): void {
    this.modalTemplatesService.openLegalModal();
  }

  /**
   * Abre la modal de centro de ayuda
   */
  openHelpModal(): void {
    this.modalTemplatesService.openHelpModal();
  }
}
